import React from 'react'
import '../buttons.css';

const Buttons = ({handleClick,handleClean,handleResulat,handleClickSign}) =>{
    return(
        <div className='Buttons'>
            <div className='buttonsChiffre'> 
                <button onClick={handleClean}>AC</button>
                <button>+/-</button>
                <button>%</button>
                    <button onClick={(event) => handleClick(event)}  nbr={1}>1</button>
                    <button onClick={(event) => handleClick(event)}  nbr={2}>2</button>
                    <button onClick={(event) => handleClick(event)}  nbr={3}>3</button>
                    <button onClick={(event) => handleClick(event)}  nbr={4}>4</button>
                    <button onClick={(event) => handleClick(event)}  nbr={5}>5</button>
                    <button onClick={(event) => handleClick(event)}  nbr={6}>6</button>
                    <button onClick={(event) => handleClick(event)}  nbr={7}>7</button>
                    <button onClick={(event) => handleClick(event)}  nbr={8}>8</button>
                    <button onClick={(event) => handleClick(event)}  nbr={9}>9</button>
                    <button onClick={(event) => handleClick(event)}  nbr={0}>0</button>
                <button nbr='.'>.</button>
           </div>
           <div className='buttonsSigne'>
                    <button onClick={(event) => handleClickSign(event)} sign='+'>+</button>
                    <button onClick={(event) => handleClickSign(event)} sign='-'>-</button>
                    <button onClick={(event) => handleClickSign(event)} sign='*'>x</button>
                    <button onClick={(event) => handleClickSign(event)} sign='/'>/</button>
                <button onClick={handleResulat}>=</button>
           </div>
        </div>
    )
}
export default Buttons